import { useRouterState } from '@tanstack/react-router'

import { BootSpinner } from '@/components/common/boot-spinner'

import { RoutePending } from './route-pending'

export function DefaultRoutePending() {
  const isFirstLoad = useRouterState({
    select: (state) => !state.resolvedLocation,
  })

  return isFirstLoad ? <BootSpinner /> : <RoutePending />
}
